import React from 'react';
import { ui } from './ui';

// Slide-in drawer showing the extracted chapter text page by page.
function TextDrawer({ drawer, onClose }) {
  if (!drawer) return null;
  return (
    <div style={ui.drawerWrap} onClick={onClose}>
      <div style={ui.drawer} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <div style={{ fontWeight: 800, fontSize: 16 }}>Extracted text {drawer.data ? `— ${drawer.data.filename}` : ''}</div>
          <button style={ui.btnSmall} onClick={onClose}>✕ Close</button>
        </div>
        {drawer.loading && <div>Loading…</div>}
        {drawer.error && <div style={ui.errorBox}>{drawer.error}</div>}
        {drawer.data && drawer.data.pages.map((p) => (
          <div key={p.page} style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: '#4338ca', marginBottom: 3 }}>PAGE {p.page}</div>
            <div style={{ whiteSpace: 'pre-wrap', fontSize: 13, lineHeight: 1.5, color: '#111827' }}>{p.text || '(no text on this page)'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TextDrawer;
